const maxTextField = (value) => {
    if(typeof(value) === "string" && value.length > 250){
        return("Must be less than 250 characters")
    }
}

export default maxTextField;